import React from 'react';
import { useAuth } from '../auth/AuthContext';

const GuestBanner = ({ page }) => {
  const { user } = useAuth();

  // ✅ Standardize guest detection
  if (!user?.isGuest) return null;

  const messages = {
    overview:
      'As a guest, your overview stats are temporary and will not persist after logout or refresh.',
    journal:
      'As a guest, your journal entries are temporary and will not persist after logout or refresh.',
    risk:
      'You’re exploring FlowQuant in Guest Mode. Your calculations will remain available during this session but won’t persist after logout or refresh. Create a free account to permanently save your risk calculations, track your performance over time, and unlock the full FlowQuant experience.',
  };

  return (
    <div className="mb-6 p-3 rounded bg-blue-900/30 border border-blue-700 text-blue-300 text-sm">
      {messages[page] || 'Guest session active. Data will not persist after logout or refresh.'}
    </div>
  );
};

export default GuestBanner;